import React from "react";

interface StockStatusBadgeProps {
  status: string;
}

const StockStatusBadge: React.FC<StockStatusBadgeProps> = ({ status }) => {
  const lower = status?.toLowerCase();

  // Pick colors based on status
  const colors: any = {
    "low stock": {
      bg: "#F8D7DA",  // pastel red (as screenshot)
      color: "#B71C1C", // dark red
    },
    "in stock": {
      bg: "#D4F8D4", // pastel green
      color: "#2E7D32", // dark green
    },
  };

  const selected = colors[lower] || {
    bg: "#EEE",
    color: "#555",
  };

  return (
    <span
      style={{
        backgroundColor: selected.bg,
        color: selected.color,
        padding: "4px 12px",
        borderRadius: "20px",   // fully rounded pill
        fontSize: "12px",
        fontWeight: 500,
        textTransform: "capitalize",
      }}
    >
      {status}
    </span>
  );
};

export default StockStatusBadge;
